/**
 * `/terms` -- the terms of use (issue #1340, ruled D367.3 by Andreas,
 * 2026-10-20: build the page and its links now, legal text as placeholders,
 * everything HIDDEN until the placeholders are filled).
 *
 * THIS FILE HOLDS NO LEGAL WORDING. Every section body is the literal
 * placeholder (written out in full on each of the eleven sections, so one
 * search for it finds every place to fill) and the date is `[DATE]`; the words are Andreas's to
 * supply. An executor never writes them, not even sensible boilerplate.
 *
 * WHY IT IS HIDDEN. `DEV_SPLIT_ENABLED` is unset, so every green merge goes
 * to the live site. A page that shows the placeholder must never be visible
 * there. `termsReady()` is the one switch: it is false while ANY section
 * body, or the date, still holds a placeholder. While it is false the page
 * (`pages/TermsOfUse.jsx`) redirects to `/` and no screen draws a link to
 * it. Filling the last placeholder in is what turns the page and every link
 * on, with no other change.
 *
 * The section headings are the planner's default (open to Andreas's veto).
 * Named exports only, mirroring `lib/privacyNotice.js`.
 */

export const TERMS_TITLE = "Terms of use";

/** The date placeholder; shown after the label once filled in. */
export const TERMS_UPDATED = "[DATE]";

export const TERMS_UPDATED_LABEL = "Last updated";

export const TERMS_SECTIONS = [
  { id: "who-we-are", heading: "Who we are", body: "[TERMS TEXT]" },
  { id: "who-can-use", heading: "Who can use CricketCompass", body: "[TERMS TEXT]" },
  { id: "juniors", heading: "Juniors and guardians", body: "[TERMS TEXT]" },
  { id: "your-account", heading: "Your account", body: "[TERMS TEXT]" },
  { id: "your-content", heading: "What you put in the app", body: "[TERMS TEXT]" },
  { id: "fair-use", heading: "Using the app fairly", body: "[TERMS TEXT]" },
  { id: "changes", heading: "Changes to the app and these terms", body: "[TERMS TEXT]" },
  { id: "ending", heading: "Ending your account", body: "[TERMS TEXT]" },
  { id: "responsibility", heading: "Our responsibility to you", body: "[TERMS TEXT]" },
  { id: "law", heading: "New Zealand law", body: "[TERMS TEXT]" },
  { id: "contact", heading: "Contact us", body: "[TERMS TEXT]" },
];

// The two literal placeholders, matched as patterns so the literal text of the
// body placeholder appears once per section in this file and nowhere else.
const PLACEHOLDER_PATTERNS = [/\[TERMS TEXT\]/, /\[DATE\]/];

function hasPlaceholder(text) {
  return typeof text !== "string" || PLACEHOLDER_PATTERNS.some((pattern) => pattern.test(text));
}

/**
 * True only when no section body and not the date still holds a
 * placeholder. `sections` / `updated` default to this module's own copy; the
 * parameters exist so a unit test can hand it a filled fixture.
 */
export function termsReady(sections = TERMS_SECTIONS, updated = TERMS_UPDATED) {
  if (hasPlaceholder(updated)) return false;
  return sections.every((section) => !hasPlaceholder(section.body));
}
